import { useEffect } from "react";

const BASE = "WealthyPlanet";

/** Sets `document.title` to "<title> · WealthyPlanet" (or just the brand for `null`). */
export function usePageTitle(title: string | null) {
  useEffect(() => {
    const prev = document.title;
    document.title = title ? `${title} · ${BASE}` : BASE;
    return () => {
      document.title = prev;
    };
  }, [title]);
}
